import clsx from "clsx";
import React, { FC } from "react";

const SeparateSpace: FC<{ className?: string }> = ({ className }) => {
  return <div className={clsx("h-2.5", className)} />;
};

export default SeparateSpace;
